import { INode } from "../_interface/INode";
import { GetExclusiveId } from "../../utils/tools"
import Resize from "../_decorationTools/resize";

export class NodeModel extends INode {
    constructor(nameClass) {
        super(nameClass)
        this.id = GetExclusiveId();
        this.idName = `${nameClass}-${this.id}`
        this.x = 0;
        this.y = 0;
        this.height = 20;
        this.width = 120;
        this.decorator = null;
        this.readOnly = false;
        this.visible = true;
        this.expressionVisible = "",
        this.data = []
        
        this.setStatus = (block) => {
            this.readOnly = block
            if (block) {
                this.decorator.setReadyOnly();
                this.visibleApply();
            }
        }

        this.visibleApply = function() {
            if (this.expressionVisible)
                this.decorator.isInvisible();
        }

        this.simpleCopyFrom = function(node) {
            try {
                this.id = node.id;
                this.idName = node.idName
                this.type = node.type;
                this.x = node.x;
                this.y = node.y;
                this.height = node.height;
                this.width = node.width;
                this.readOnly = node.readOnly;
                this.expressionVisible = node.expressionVisible;
                // this.data = node.data ? node.data.map(d => new Properties({...d, id: '' })) : []
            } catch (e) {
                console.log(`simpleCopyFrom falha ao copiar o nó ${this.idName}. Falha: \n${e}`)
            }
        }

        this.move = function() {
            try {
                this.decorator.move();
            } catch (e) {
                throw `Classe ${nameClass} metodo move.\nError:${e}`
            }
        }

        this.isSelected = function() {
            try {
                this.decorator.createSelectorArea();
            } catch (e) {
                throw `Classe ${nameClass} metodo isSelected.\nError:${e}`
            }
        }

        this.reloadProperties = async function() {
            try {
                if (this.data && this.data.length > 0) {
                    this.decorator.reloadProperties();
                }
            } catch (e) {
                throw `Classe ${nameClass} metodo reloadProperties.\nError:${e}`
            }
        }

        this.kill = () => {
            try {
                this.decorator.disappear();
            } catch (e) {
                throw `Classe ${nameClass} metodo kill.\nError:${e}`
            }
        }

        this.isVisible = () => !!document.querySelector(`#${this.idName}`)

        this.hasPropertieOnData = (prop) => !!this.data.find(p => p.isEquals(prop))

        this.updateData = (propToUpdate) => {
            let propFound = this.data.find(p => {
                return p.isEquals(propToUpdate)
            })
            if(propFound){
                propFound.value = propToUpdate.value ? propToUpdate.value : propFound.value
            }
        }

        this.applyProperties = (nodeEdited) => {
            try {
                Resize.setDimension(this)
                this.height = nodeEdited.height
                this.width = nodeEdited.width
                this.decorator.applyProperties(Resize)
            }
            catch(e)
            {
                throw `Classe ${nameClass} metodo applyProperties.\nError:${e}`
            }
        }

        this.isEquals = function(node) {
            return this.id == node.id
        }

        this.rebuildStructure = function() {
            
        }
    }
}